import API_BASE_URL from "../config";

const authHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

const handle = async (res) => {
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(text || `Request failed with status ${res.status}`);
  }
  if (res.status === 204) return null;
  const text = await res.text();
  return text ? JSON.parse(text) : null;
};

export const getTaskChecklist = (taskId) =>
  fetch(`${API_BASE_URL}/api/tasks/${taskId}/checklist`, { headers: authHeaders() }).then(handle);

export const applyTemplateToTask = (taskId, templateId) =>
  fetch(`${API_BASE_URL}/api/tasks/${taskId}/checklist/apply-template`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ templateId }),
  }).then(handle);

export const addAdhocItem = (taskId, text) =>
  fetch(`${API_BASE_URL}/api/tasks/${taskId}/checklist/items`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ text }),
  }).then(handle);

export const toggleChecklistItem = (taskId, itemId) =>
  fetch(`${API_BASE_URL}/api/tasks/${taskId}/checklist/items/${itemId}/toggle`, {
    method: "PATCH",
    headers: authHeaders(),
  }).then(handle);

export const deleteChecklistItem = (taskId, itemId) =>
  fetch(`${API_BASE_URL}/api/tasks/${taskId}/checklist/items/${itemId}`, {
    method: "DELETE",
    headers: authHeaders(),
  }).then(handle);
